<template>
    <router-view v-slot="{ Component }" v-if="isVue3">
        <transition mode="out-in" name="fade-transform">
            <keep-alive :include="keepAliveIncludeList" :max="customize.keepAliveMax" v-if="customize.keepAliveMode == 'include'">
                <component :is="Component" :key="key"/>
            </keep-alive>
            <keep-alive :exclude="keepAliveExcludeList" :max="customize.keepAliveMax" v-else>
                <component :is="Component" :key="key"/>
            </keep-alive>
        </transition>
    </router-view>
    <transition name="fade-transform" mode="out-in" v-else>
        <keep-alive :include="keepAliveIncludeList" :max="customize.keepAliveMax" v-if="customize.keepAliveMode == 'include'">
            <router-view :key="key"></router-view>
        </keep-alive>
        <keep-alive :exclude="keepAliveExcludeList" :max="customize.keepAliveMax" v-else>
            <router-view :key="key"></router-view>
        </keep-alive>
    </transition>
</template>
<script>
  import {onMessage} from '../../../utils/event-bus';
  import Constants from '../../../utils/constants';
  import Global from '../../../utils/global';
  import { mapMutations, mapState } from 'vuex';
  export default {
    name: 'KiafKeepAlive',
    computed: {
        isVue3(){
          return this.$global.isVue3();
        },
      ...mapState({
        keepAliveIncludeList: state => state.kiaf.keepAliveIncludeList
      }),
      key() {
        if(this.customize.keepAliveKey && typeof this.customize.keepAliveKey == 'function'){
          return this.customize.keepAliveKey();
        }else{
          // let fullPath = this.$route.fullPath.split('#')[0];
          // if(fullPath.indexOf('?chromeExtWin=Y') > 0){
          //   fullPath = fullPath.replace('?chromeExtWin=Y', '');
          // } else if(fullPath.indexOf('&chromeExtWin=Y') > 0){
          //   fullPath = fullPath.replace('&chromeExtWin=Y', '');
          // }
          let fullPath = this.$util.getMatchPath(this.$route.fullPath.split('#')[0], { replaceTime: false });
          if(this.$route.params && this.$route.params.routeParamsId){
            fullPath += this.$route.params.routeParamsId;
          }
          return fullPath;
        }
      },
      keepAliveExcludeList(){
        let result = this.$store.state.kiaf.keepAliveExcludeList.concat(Global.getKeepAliveExcludeList());
        return result;
      }
    },
    props: {
      customize: {
        type: Object,
        default(){
          return {
            keepAliveMax: 0
          };
        }
      }
    },
    data() {
      return {
        pageName: ''
      };
    },
    created() {
      this.KIAF_KEEP_ALIVE_SET_INCLUDE(this.keepAliveIncludeList.concat(Global.getKeepAliveIncludeList()));
      onMessage(Constants.EVENT_BUS_CODE_REMOVE_TAG, (data) => {
        if(this.customize.navbar && this.customize.navbar.handleOnTagDelete && typeof this.customize.navbar.handleOnTagDelete === 'function'){
          this.pageName = '';
          if(!data.pageName){
            let path = data.url.split('?')[0];
            this.getPageName(this.$router.options.routes, '', path);
            if(this.pageName){
              data.pageName = this.pageName;
            }
          }
          this.customize.navbar.handleOnTagDelete(data);
        } else {
          if(data.pageName){
            if(this.customize.keepAliveMode == 'include'){
              let index = this.keepAliveIncludeList.indexOf(data.pageName);
              if(index >= 0){
                this.keepAliveIncludeList.splice(index, 1);
                setTimeout(() => {
                  this.KIAF_KEEP_ALIVE_PUSH_INCLUDE(data.pageName); //清空exclude,避免无法继续缓存该页面
                }, 1000);
              }
            } else {
              this.KIAF_KEEP_ALIVE_PUSH_EXCLUDE(data.pageName);//也可以通过tag.tagId或者tag.url获取对应vue的pageName，然后放到exclude中,注意，路由中配置的name一定要和组件里定义的name保持一致，不然无法清除keepAlive的缓存
              setTimeout(() => {
                this.KIAF_KEEP_ALIVE_SET_EXCLUDE([]); //清空exclude,避免无法继续缓存该页面
              }, 1000);
            }
            return;
          }
          let url = data.url;
          let cache = [];
          let keys = [];
          if(this.$vnode.componentInstance && this.$vnode.componentInstance._vnode && this.$vnode.componentInstance._vnode.componentInstance){
            if(this.$vnode.componentInstance._vnode.componentInstance.cache){
              cache = this.$vnode.componentInstance._vnode.componentInstance.cache;
            }
            if(this.$vnode.componentInstance._vnode.componentInstance.keys){
              keys = this.$vnode.componentInstance._vnode.componentInstance.keys;
            }
          }
          if (keys.length) {
            let key = '';
            let index = 0;
            for(let i = 0; i < keys.length; i++){
              if(keys[i].indexOf(url) >= 0){
                index++;
                key = keys[i];
              }
            }
            if (index > -1) {
              keys.splice(index, 1);
            }
            delete cache[key];
          }
        }
      });
    },
    methods: {
      ...mapMutations({
        KIAF_KEEP_ALIVE_SET_INCLUDE: 'KIAF_KEEP_ALIVE_SET_INCLUDE',
        KIAF_KEEP_ALIVE_SET_EXCLUDE: 'KIAF_KEEP_ALIVE_SET_EXCLUDE',
        KIAF_KEEP_ALIVE_PUSH_EXCLUDE: 'KIAF_KEEP_ALIVE_PUSH_EXCLUDE',
        KIAF_KEEP_ALIVE_PUSH_INCLUDE: 'KIAF_KEEP_ALIVE_PUSH_INCLUDE'
      }),
      getPageName(items, parentPath, path){
        if(Array.isArray(items)){
          for(let i = 0; i < items.length; i++){
            let item = items[i];
            let nextParentPath = item.path;
            if(parentPath){
              if(item.path && item.path.indexOf('/') === 0){
                nextParentPath = parentPath + item.path;
              } else {
                nextParentPath = parentPath + (item.path ? ('/' + item.path) : '');
              }
            }
            if(Array.isArray(item.children)){
              this.getPageName(item.children, nextParentPath, path);
            } else {
              if(nextParentPath === path){
                this.pageName = item.name;
                break;
              }
            }
          }
        }
      }
    }
  };
</script>

<style scoped>

</style>
